import './style.css';
import { StrictMode } from 'react';

import * as ReactDOM from 'react-dom/client';

import App from './app/app';
import { prefetchCriticalRoutes } from './shared/prefetch-critical-routes';

window.__HOST_VERSION__ = __HOST_VERSION__;

window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    window.location.reload(); // refreshes page when a new deployment is spotted
});

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);
root.render(
    <StrictMode>
        <App />
    </StrictMode>,
);

prefetchCriticalRoutes();
